var head = document.head;
var link = document.createElement("link");
link.rel = "stylesheet";
link.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
head.appendChild(link);
var script = document.createElement("script");
script.type = "text/javascript";
script.async = true;
script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
head.appendChild(script);

document.addEventListener("DOMContentLoaded", function () {
    function currencyFormat(n) {
        return Intl.NumberFormat("in-ID", {
            style: "currency",
            currency: ((window.Shopify || {}).currency || {}).active || "EUR",
            currencyDisplay: "symbol",
        }).format(n);
    }

    function initializeSwiper() {
        new Swiper('.swiper_sizes', {
            slidesPerView: "auto",
            autoHeight: true,
            loop: false,
        });
    }

    function runWhenSwiperLoaded(callback) {
        if (window.Swiper) {
            callback();
        } else {
            setTimeout(() => runWhenSwiperLoaded(callback), 100);
        }
    }

    runWhenSwiperLoaded(function () {
        fetch("https://femdisc.de/products/menstruationsscheibe.js")
            .then(response => response.json())
            .then(product => {
                let optionName = product.options[0].name;
                let selectedVariant = localStorage.getItem('selectedVariant');
                let variants = product.variants.flatMap(
                    ({ available, id, compare_at_price, price, option1, title }) =>
                        available ? [{
                            id,
                            option: option1,
                            price: currencyFormat(price / 100),
                            compare_at_price: compare_at_price > price ? currencyFormat(compare_at_price / 100) : '',
                            title: /regular.*small/i.test(title) ? "Regular + Small" : `${title} + ${title}`,
                            checked: selectedVariant == id ? 'checked' : ''
                        }] : []
                );
                let target = document.querySelector("product-info variant-radios fieldset.product-form__input");
                let form = document.querySelector(`product-form form[id^="product-form-template"][id$="_main"]`);
                let formId = form.getAttribute("id");
                let inputId = formId.replace(/^product-form-/i, "");
                target.innerHTML = "";
                target.insertAdjacentHTML(
                    "beforebegin",
                    variants.reduce(
                        (r, v, idx) =>
                            (r += `<div class="swiper-slide">
                                <div class="prodct_sizer_box">
                                    <input type="radio" id="${inputId}-1-${idx}" name="${optionName}" value="${v.option}" form="${formId}" ${v.checked} ${idx === 0 && !v.checked ? 'checked' : ''}>
                                    <label for="${inputId}-1-${idx}" class="variant_label" data-id="${v.id}">
                                        <span class="variant_title">${v.title}</span>
                                        <span class="visually-hidden">Variante ausverkauft oder nicht verfügbar</span>
                                        <div class="variant-sale">
                                            <div class="sale"><span>Sale</span></div>
                                        </div>
                                        <div class="variant-price">
                                            <span class="variant_compare-price">${v.compare_at_price}</span>
                                            <span class="variant_price">${v.price}</span>
                                        </div>
                                        <div class="variant_description">
                                            <span>Kaufe 1, <br>erhalte 1 gratis dazu</span>
                                        </div>
                                    </label>
                                </div>
                            </div>`),
                        `<fieldset class="js product-form__input new_product-form-input"><legend class="form__label">${optionName}</legend><div class="swiper_sizes"><div class="swiper-wrapper">`
                    ) + '</div></div></fieldset>'
                );
                target.remove();
                initializeSwiper();
                
                document.querySelectorAll('.variant_label').forEach(label => {
                    label.addEventListener('click', () => {

                        const variantId = label.getAttribute('data-id');
                        localStorage.setItem('selectedVariant', variantId);
                        console.log('Variant saved:', variantId);
                    });
                });

                if (selectedVariant) {
                    let selectedLabel = document.querySelector(`.variant_label[data-id="${selectedVariant}"]`);
                    if (selectedLabel) {
                        selectedLabel.click();
                        console.log('Performed click on the last selected variant:', selectedVariant);
                    }
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    });
});
